<template>
  <div class="scroll-container">
    <v-btn-toggle v-model="selected" tile class="d-flex mb-4 px-4">
      <v-tooltip
        v-for="({ key, label, caption, disabled }, index) in items"
        :key="`button-select-${key}-${index}`"
        :disabled="!disabled"
        top
      >
        <template v-slot:activator="{ on }">
          <div class="grow d-flex" v-on="on">
            <v-btn
              :value="key"
              :disabled="disabled"
              class="grow select-day-button"
              v-bind="value === key ? { color: 'primary' } : {}"
              :class="{ 'mr-2': index < items.length }"
            >
              <div class="d-flex flex-column">
                <span>{{ label }}</span>
                <span class="caption">{{ caption }}</span>
              </div>
            </v-btn>
          </div>
        </template>
        <span>{{ tooltip }}</span>
      </v-tooltip>
    </v-btn-toggle>
  </div>
</template>
<script>
export default {
  name: 'ButtonSwitcher',
  props: {
    value: {
      type: [String, Number, Object],
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      item: null,
    }
  },
  computed: {
    selected: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
<style>
.select-day-button {
  border-left-width: 1px !important;
}
</style>
<style scoped>
.scroll-container {
  overflow-x: auto;
}
</style>
